<template>
  <div id="promotion-complete">
    <div class="content">
      <p>{{ $t('common.campaignCompleted') }}</p>
      <p class="amount">${{ accountInfo.creditToBalance }}</p>
      <p>{{ $t('common.transferredToYourActiveAccount') }}</p>
      <p>{{ accountInfo.accountType }} - {{ accountInfo.mt4Account }}</p>
    </div>
    <div class="footer">
      <p class="title">{{ $t('common.moreCampaignRecommendations') }}</p>
      <div class="btn-container">
        <a href="https://www.vtmarketscn.com/promotions/" target="_blank">
          <Button v-bind="getStyle()">{{ $t('common.checkMoreOngoingPromotion') }}</Button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/interact/Button.vue';
import { btnStyleConfig } from '@/constants/style';

export default {
  name: 'PromotionComplete',
  components: { Button },
  props: {
    accountInfo: { type: Object }
  },
  data() {
    return { btnStyleConfig };
  },
  methods: {
    getStyle() {
      btnStyleConfig.BTN_DEFAULT.bgColor = 'transparent';
      return btnStyleConfig.BTN_DEFAULT;
    }
  }
};
</script>

<style lang="scss" scoped>
#promotion-complete {
  .content {
    color: $primary-blue;
    font-size: 32px;
    font-weight: 600;
    padding: 60px 0;

    @media (max-width: $DEVICE_SIZE_MOBILEL) {
      font-size: 24px;
    }
  }

  p {
    margin: 20px 0;
  }

  .amount {
    font-family: Oblivian-Black;
    font-size: 56px;
    font-weight: 700;
    margin-top: 20px;
    margin-bottom: 60px;

    @media (max-width: $DEVICE_SIZE_MOBILEL) {
      font-size: 35px;
    }
  }

  .footer {
    background-color: #f1f1f1;
    width: 100%;
    padding: 40px 0;
    padding-bottom: 70px;
    display: flex;
    flex-direction: column;

    .title {
      font-weight: bold;
      color: #000d28;
      margin-bottom: 30px;
    }

    .btn-container {
      margin: auto;
    }
  }
}
</style>
